import React from 'react'
import '../container.css'

const TurunuBul = () => {
    return (
        <div className="info-pages-container">
            <h2 id="head">Adım Adım Türünü Bul</h2>
            <br></br>
            <p>Bu web sitesi ile ODTÜ arazisinde görülen bitki türlerini tanımanıza, ismini bulmanıza
ve bitki türleriyle ilgili daha fazla araştırma yapmanıza yardımcı olacak bir kaynak
hazırlamaya çalıştık. Aşağıdaki adımları takip ederek “Çiçeğini Bul” bölümüne girin ve
türünüzü bulun.</p>
            <br></br>
            <ol style={{ textAlign: "left" }}>
                <li>İlk aşamada otsu bir bitki veya kır çiçeğini mi yoksa ağaç ve çalıyı mı tanımlamak
istediğinize karar vermeniz gerekiyor.</li>
                <br></br>
                <li>Eğer örneğiniz otsu bitki veya kır çiçeği ise önce çiçek rengine bakmalısınız.</li>
                <br></br>
                <li>Seçtiğiniz renkten sonra karşınıza çiçek şekilleri çıkacak, bu noktada da çiçeğinizin
şekline karar vermelisiniz.</li>
                <br></br>
                <li>Dördüncü aşamada da bitkinizin yaklaşık boyutunu tahmin etmeniz gerekiyor.</li>
                <br></br>
                <li>Son aşamada da karşınıza çıkan fotoğraf örnekleri ile bitkinizi karşılaştırıp türünüzü
tanımlamaya çalışabilirsiniz.Bu aşamada türünüzün yaprak şekline, dizilişine, çiçek
yoğunluğuna, genel görünüşüne dikkat etmeniz iyi olur.</li>
                <br></br>
                <li>Eğer örneğiniz ağaç veya çalı ise, türünüzün yaprak şekline bakarak ayırt etmeye
çalışmalısınız.</li>
                <br></br>
                <li>İlk aşamada iğne yapraklı mı, geniş yapraklı mı olduğuna bakmanız gerekiyor.</li>
                <br></br>
                <li>Daha sonra da yaprak şekline dikkat etmelisiniz.Üçüncü aşamada da karşınıza çıkan
örneklere bakarak türünüzü tanımlamaya çalışabilirsiniz.</li>
                <br></br>
                <li>Bu aşamada, tohum ve meyveler için kataloğumuz kısıtlı olduğundan bütün fotoğrafları
tek aşamada tarayabilirsiniz.</li>
                <br></br>
            </ol>
            <br></br>
            <p>İyi tür avları dileriz :)</p>
            <div style={{ marginTop: 15 }}>
                <a href="#head"><i class="fas fa-arrow-up" style={{ fontSize: 30 }}></i></a>
            </div>
        </div>
    )
}

export default TurunuBul